export default {
    imageAIFormRules: {
        enterDescription: 'Vul de beschrijving in aub',
        invalidDescription: 'Vul een geldige beschrijving in aub',
        enterNumberOfVariations: 'Selecteer het aantal variaties aub',
        invalidNumberOfVariations: 'Je kunt maximaal 4 en minimaal 1 variatie genereren',
        enterStyle: 'Selecteer alstublieft ten minste één stijl',
    },
};
